import {decodeConsentString} from 'consent-string';

import {getConsentCookie, existsConsentCookie} from './consent';
import {logger} from './logger';
import {PURPOSE_CONTENT, PURPOSE_ADS} from '../constants';
import {getPreFilledPurposes, getPreFilledPurposesFromCookie} from '../purposes';
import {getPreFilledVendors, getPreFilledVendorsFromCookie} from '../vendors';
import vendorList from '../vendors/list';

const formData = {
  purposes: {
    [PURPOSE_CONTENT]: true,
    [PURPOSE_ADS]: true
  },
  vendors: vendorList.vendors
};

export const setFormData = data => {
  formData.purposes = data.purposes || {
    [PURPOSE_CONTENT]: true,
    [PURPOSE_ADS]: true
  };
  formData.vendors = data.vendors || vendorList.vendors;
};

export const setFormDataLoggedInUser = data => {
  formData.purposes = getPreFilledPurposes(data);
  formData.vendors = getPreFilledVendors(data);
};

export const setFormDataFromConsent = consentCookie => {
  if (!consentCookie) {
    return;
  }

  const {allowedPurposeIds, allowedVendorIds} = decodeConsentString(consentCookie);

  setFormData({
    purposes: getPreFilledPurposesFromCookie(allowedPurposeIds),
    vendors: getPreFilledVendorsFromCookie(allowedVendorIds)
  });
};

export const setPrefilledFormData = () => {
  if (!existsConsentCookie()) {
    logger(1200, 'No euconsent cookie found in local domain.');
    return;
  }

  const {allowedPurposeIds, allowedVendorIds} = decodeConsentString(getConsentCookie());

  setFormData({
    purposes: getPreFilledPurposesFromCookie(allowedPurposeIds),
    vendors: getPreFilledVendorsFromCookie(allowedVendorIds)
  });
};

export const getFormData = () => formData;
